<script>
import DataLayer from '@services/data-layer/index'
import Layout from '@layouts/main'

import Overview from '@views/channels/channel.overview'
import Schedule from '@views/channels/channel.schedule'
import History from '@views/channels/channel.history'

export default {
    components: { Layout, Overview, Schedule, History },
    props: {
        mainComponent: {
            type: String,
            default: 'Overview',
        },
    },
    page() {
        const channelTitle = this.channel.title || 'Channel'
        const title = `${channelTitle} Radio`
        const description = this.channel.description || `Listen to ${channelTitle} on FRISKY Radio.` || `Listen to FRISKY Radio`
        const image = `${process.env.VUE_APP_CLIENT_URL}/frisky-social-share-image.png`
        const canonicalUrl = `https://frisky.fm${this.$route.path}`
        return {
            title,
            link: [{ rel: 'canonical', vmid: 'canonical', href: canonicalUrl }],
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },
                { property: 'og:image', vmid: 'og:image', content: image },
                { property: 'og:type', vmid: 'og:type', content: 'website' },
                { property: 'og:url', vmid: 'og:url', content: canonicalUrl },
                { property: 'og:site_name', vmid: 'og:site_name', content: 'FRISKY' },

                { name: 'twitter:card', vmid: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', vmid: 'twitter:title', content: title },
                { name: 'twitter:description', vmid: 'twitter:description', content: description },
                { name: 'twitter:image', vmid: 'twitter:image', content: image },
                { name: 'twitter:url', vmid: 'twitter:url', content: canonicalUrl },
            ],
        }
    },
    data() {
        return {
            channel: {},
            nowPlaying: { id: 0 }
        }
    },
    computed: {
        tabs() {
            const channelId = this.$route.params.channelId
            return channelId === 'classics'
                ? [
                    {
                        to: { name: 'channel', params: { channelId } },
                        label: 'Overview',
                    },
                    {
                        to: { name: 'channel/history', params: { channelId } },
                        label: 'History',
                    },
                ]
                : [
                    {
                        to: { name: 'channel', params: { channelId } },
                        label: 'Overview',
                    },
                    {
                        to: { name: 'channel/schedule', params: { channelId } },
                        label: 'Show Schedule',
                    },
                    {
                        to: { name: 'channel/history', params: { channelId } },
                        label: 'History',
                    },
                ]
        },
        resource() {
            return {
                ...this.channel,
                type: 'channel',
                nowPlaying: this.nowPlaying,
            }
        },
        playback() {
            return this.$store.state.playback
        },
        status() {
            return this.playback?.status
        }
    },

    watch: {
        'status'(newVal) {
            this.handleUrlPlayParam()
        },
    },
    mounted() {
        this.loadData()
    },

    methods: {
        async loadData() {
            const channels = await DataLayer.channels.get()

            this.channel = Object.values(channels.body).find(channel => channel.id === this.$route.params.channelId)

            DataLayer.stationsPlaylists.subscribe(response => {
                this.nowPlaying = response.body.filter(item => item.station === this.$route.params.channelId)[0]
            })

            this.handleUrlPlayParam()
        },
        handleUrlPlayParam() {
            if (this.status === 'playing' && this.playback?.resource?.id === this.channel.id && this.playback?.resource?.type === 'channel') {
                this.$router.replace({ query: { ...this.$route.query, play: 'true' } })
            } else {
                const { play, ...rest } = this.$route.query
                const query = { ...rest }
                if (JSON.stringify(query) === JSON.stringify(this.$route.query)) return
                this.$router.replace({ query: rest })
            }
        },
    },
}
</script>

<template>
    <Layout>
        <BaseHero
            :resource="resource"
            keep-alive
        />
        <BaseTabPanel
            :tabs="tabs"
            address-navigation
        />
        <component
            :is="mainComponent"
            :channel="resource"
            :now-playing="nowPlaying"
        />
    </Layout>
</template>
